import playstore from "./ic-google-play.svg"
import mockups from "./img-mockup.png"

function SectionDownload() {
    return (
        <div id="section-download" className="section w-full flex flex-col space--2 items-center justify-around overflow-hidden
                lg:flex-row lg:space-y-0">
            <div className="flex flex-col space-y-10 items-center 
                            lg:items-start">
                <h1>جرب ClassQ مجانا لمدة ثلاث أشهر.</h1>
                <p className="text-2xl">انضم إلى المعلمين المحترفين.</p>
                <a href='https://play.google.com/store/apps/details?id=com.fourward.classq&referrer=utm_source%3Dclassq-website%26utm_medium%3Dwebsite_buttom_btn%26anid%3Dadmob'>
                    <img className="h-14" src={playstore} alt="download google play" />
                </a>
            </div>

            <img className="w-3/4 lg:w-1/3" src={mockups} alt="mockups" />
        </div>
    );
}

export default SectionDownload;
